import { render } from "./ColumnSettingsModal.vue?vue&type=template&id=565d8a34&scoped=true"
import script from "./ColumnSettingsModal.vue?vue&type=script&lang=js"
export * from "./ColumnSettingsModal.vue?vue&type=script&lang=js"

import "./ColumnSettingsModal.vue?vue&type=style&index=0&id=565d8a34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565d8a34"]])

export default __exports__